import React from "react";

const Twitter = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.0695 11.8562L26.1203 0H23.7375L15.0098 10.2945L8.03925 0H0L10.5413 15.5662L0 28H2.38275L11.5988 17.1279L18.9608 28H27L16.0672 11.8562H16.0695ZM12.807 15.7032L11.7383 14.153L3.24 1.81963H6.8985L13.7565 11.774L14.8253 13.3242L23.7397 26.2626H20.0813L12.807 15.7055V15.7032Z"
      fill={color}
    />
  </svg>
);

Twitter.defaultProps = {
  width: 28,
  height: 28,
  color: "white"
};

export default Twitter;
